<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import Button from '../Button/Button.svelte';

	export let title: string | null | undefined;
	// The entry with a section id as href.
	export let entries: Array<{ title: string; id: string }>;
	export let button: { title: string; href: string } | null;
	// The currently viewed section.
	export let currentSectionId: string;

	const dispatch = createEventDispatcher();

	function handleClick(id: string) {
		dispatch('clickLink', { id: id });
	}
</script>

<div class="flex flex-col max-w-[290px]">
	{#if title}
		<div class="text-xl font-bold">{title}</div>
	{/if}
	<div class="flex flex-col border-l-[1px] border-l-gray-500 pl-2 gap-2 mt-4">
		{#each entries as { title, id }}
			<button
				class="self-start min-h-[32px] transition-border duration-[200ms] {id === currentSectionId
					? 'border-l-[3px] border-purple text-purple px-[5px]'
					: 'border-l-[3px] border-purple/0 px-2'} -ml-[9px]"
				on:click={() => {
					handleClick(id);
				}}>{title}</button
			>
		{/each}
	</div>
	{#if button && button.href}
		<a href={button.href}>
			<div class="flex flex-row w-full justify-center items-center pt-5">
				<Button
					additionalClass="py-3 !px-0 w-full !max-w-[258px] max-h-[45px] text-white !bg-black hover:!bg-purple uppercase whitespace-nowrap"
					>{button.title}</Button
				>
			</div>
		</a>
	{/if}
</div>
